var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendAllToggleOff = function SvgSendAllToggleOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 21,
    viewBox: "0 0 36 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 1,
    y: 3.5,
    width: 34,
    height: 14,
    rx: 7,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 10.5,
    r: 10,
    fill: "#B7B7B7"
  })));
};
export { SvgSendAllToggleOff as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAzNiAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgb3BhY2l0eT0iMC41IiB4PSIxIiB5PSIzLjUiIHdpZHRoPSIzNCIgaGVpZ2h0PSIxNCIgcng9IjciIGZpbGw9IndoaXRlIi8+CjxjaXJjbGUgY3g9IjExIiBjeT0iMTAuNSIgcj0iMTAiIGZpbGw9IiNCN0I3QjciLz4KPC9zdmc+Cg==";